<template>
  <div>
    <modal
      class="output_options-modal"
      width="460px"
      height="130px"
      :backdrop="false"
      :value="showModal"
      effect="fade"
      @closed="closed"
      large
    >
      <!-- custom header -->
      <div slot="modal-header" class="modal-header"  v-if="textTitle && textTitle.length > 0">
        <h4 class="modal-title" >
          <center>
            <strong>{{textTitle}} </strong>
          </center>
        </h4>
      </div>
      <div slot="modal-header" class="modal-header" style="display:none;"  v-else/>

      <div
        class="modal-body output_options-modal-body"
        style="height: 150px;padding: 0px 15px; overflow-x: auto;"
      > 
      <span v-html="messageLabel"></span>
      <span v-html="inputPrefix"></span>
        <input
          ref="local_value"
          style="width:80px;display: inline;"
          type="number"
          class="form-control"
          :min="minVal"
          v-on:input="updateValue($event.target.value)"
          id="local_value"
          name="local_value"
          v-bind:value="localValue"
          @keyup="keyUp($event.target.id,$event.target.value, $event)"
          placeholder
        />
        <span v-html="inputSuffix"></span>
      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <button type="button" class="btn btn-default"  :style="yesStyle"
        @click="closed('no')">{{noLabel}}</button>
        <button type="button" class="btn btn-primary"   :style="noStyle"
        :disabled="localValue < minVal"
        @click="closed('yes')" >{{yesLabel}}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
var vm = this;

import modal from "./local-modal";

Vue.component("modal", modal);
import _ from "lodash";
import debug from "debug";
var debug_input_manual = debug("esma:input-modal");

export default {
  data() {
    return {
      min_val: -1,
      show_modal: false,
      title_label: "",
      callback: null,
      local_value: "",
      message_label:"",
      input_prefix:"",
      input_suffix:"",
      yes_label: "Yes",
      no_label: "No",
      yes_style:"",
      no_style:""
    };
  },
  computed: {
    minVal:{
      get(){
        return this.min_val;
      },
      set(v){
        this.min_val = v;
      }
    },
    messageLabel:{
      get(){
        return this.message_label;
      },
      set(v){
        this.message_label = v;
      }
    },
    inputPrefix:{
      get(){
        return this.input_prefix;
      },
      set(v){
        this.input_prefix = v;
      }
    },
    inputSuffix:{
      get(){
        return this.input_suffix;
      },
      set(v){
        this.input_suffix = v;
      }
    },
    yesLabel:{
      get(){
        return this.yes_label;
      },
      set(v){
        this.yes_label = v;
      }
    },
    noLabel:{
      get(){
        return this.no_label;
      },
      set(v){
        this.no_label = v;
      }
    },
    yesStyle:{
      get(){
        return this.yes_style;
      },
      set(v){
        this.yes_style = v;
      }
    },
    noStyle:{
      get(){
        return this.no_style;
      },
      set(v){
        this.no_style = v;
      }
    },
    localValue: {
      get() {
        return this.local_value;
      },
      set(v) {
        console.log("showModalWindow Set localValue", v);
        this.local_value = v;
      },
    },
    pageID() {
      return this.$props.pageid;
    },
    textTitle() {
      return this.title_label;
    },
    showModal() {
      return this.show_modal;
    },
  },
  methods: {
    keyUp(id, value, event) {
      if (event.key == "Enter" || event.keyIdentifier == "Enter") {
        this.closed("yes");
      }
    },
    updateValue(val) {
      this.$notify({clean:true})
       if( ( isNaN(val) || (this.minVal !== false && parseInt(val) < this.minVal))){
        val = parseInt(val.replace(/[^0-9-.]/g, '') || 0)
        // if(isNaN(val)){
        //   val = "";
        // }
        if(val < this.minVal){
          val = "";
        }
        this.$notify({
          title: (this.minVal || 0) + '以下の数量を登録することはできません。',
          text: "",
          type: 'error',
          duration: 3000
        });
        this.localValue = "";
        setTimeout(() => {
          this.localValue = val;
        }, 100);
      }else{
        this.localValue = val;
      }

      
      // this.$emit('inputed', this.localValue);
    },
    onShow() {},
    showModalWindow(data) {
      debug_input_manual("showModalWindow data", data);
      this.onShow();
      this.minVal = data.min_val || -1;
      this.title_label = data.title;
      this.inputPrefix = data.input_prefix ||"";
      this.messageLabel = data.message ||"";
      this.inputSuffix = data.input_suffix || "";
      this.yesLabel = data.yes_label;
      this.noLabel = data.no_label;
      this.yesStyle = data.yes_style;
      this.noStyle = data.no_style;


      this.show_modal = true;
      // this.$emit('inputed', this.localValue);
      this.$refs.local_value.focus();
      setTimeout(() => {
        this.$refs.local_value.focus();
      }, 100);
    },
    closed(mode) {
      debug_input_manual("mode", mode);
      this.$emit("closed", { mode: mode, value: this.localValue });
      this.show_modal = false;
    },
  },
  props: {
    tag: { type: String, default: "showInputNumberModal" },
    pageid: { type: String },
  },
  mounted() {
    debug_input_manual("On mounted");
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  },
};
</script>
<style scoped>
.info_div {
  width: 32%;
  float: left;
}
.esma_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.esma_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// input-number-modal.vue?54c25558